import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { R } from "../resources";

interface NavProps {
  onCta: (e?: React.MouseEvent) => void;
  ctaLabel: string;
}

const NAV_ITEMS = [
  { label: "Solutions", to: "/solutions" },
  { label: "Science", to: "/science" },
  { label: "Verticals", to: "/verticals" },
  { label: "About", to: "/about-us" },
];

export default function Nav({ onCta, ctaLabel }: NavProps) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close the menu whenever the route changes.
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  // While open: lock body scroll and close on Escape.
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open]);

  const handleMobileCta = (e: React.MouseEvent) => {
    e.preventDefault();
    setOpen(false);
    onCta(e);
  };

  return (
    <header className={scrolled ? "nav scrolled" : "nav"} data-open={open}>
      <div className="wrap nav-inner">
        <Link className="brand" to="/" onClick={() => setOpen(false)}>
          <img src={R.udLogo} alt="Upside Digital" />
          <span className="brand-word">Upside Digital</span>
        </Link>

        <nav className="nav-links">
          {NAV_ITEMS.map((item) => (
            <Link key={item.to} to={item.to}>
              {item.label}
            </Link>
          ))}
          <a href="#" onClick={onCta}>Contact</a>
        </nav>

        <button className="nav-cta" onClick={onCta}>
          {ctaLabel} <span className="arrow">→</span>
        </button>

        <button
          type="button"
          className="nav-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="mobile-menu"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="nav-toggle-bars" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
        </button>
      </div>

      <div className="nav-mobile" id="mobile-menu">
        <nav className="nav-mobile-links">
          {NAV_ITEMS.map((item) => (
            <Link key={item.to} to={item.to} onClick={() => setOpen(false)}>
              {item.label}
            </Link>
          ))}
          <a href="#" onClick={handleMobileCta}>Contact</a>
        </nav>
        <button className="nav-mobile-cta" onClick={handleMobileCta}>
          {ctaLabel} <span className="arrow">→</span>
        </button>
      </div>

      <div className="nav-backdrop" onClick={() => setOpen(false)} aria-hidden="true" />
    </header>
  );
}